import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'
import { ClinPageContentFrame } from '../../../components/ClinPageContentFrame'
import { mediaQueryDown } from '../../../utils/mediaQuery'
import { ClinText } from '../../../components/ClinText'
import { ClinButton } from '../../../components/ClinButton'
import { ClinGroup } from '../../../components/ClinGroup'

interface IStyledFixedWidthContainerProps {
  width?: number
}

const desktopUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledLoadingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    marginBottom: '16px !important'
  }
})

export const StyledLoadingSpinner = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginLeft: ClinTheme.space[2]
})

export const StyledInviteHeaderContainer = styled.div({
  maxWidth: '100%',
  margin: '0 auto',
  backgroundColor: ClinTheme.colors.white
})

export const StyledHeaderClinPageContentFrame = styled(ClinPageContentFrame)({
  padding: '24px 0',
  marginBottom: '24px !important',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    padding: '16px 0'
  }
})

export const StyledInviteHeaderTitle = styled(ClinText)({
  fontFamily: ClinTheme.fonts.groteskExtraBold,
  fontWeight: ClinTheme.fontWeights.bolder,
  color: ClinTheme.colors.black,
  margin: 0,

  [mediaQueryDown(desktopUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[4],
    marginLeft: ClinTheme.space[2]
  }
})

export const StyledInviteHeaderNavigation = styled.div({
  display: 'flex',
  alignItems: 'center',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[4]
  }
})

export const StyledDesktopOnly = styled.div({
  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'none'
  }
})

export const StyledFormClinPageContentFrame = styled(ClinPageContentFrame)({
  backgroundColor: ClinTheme.colors.white,
  padding: '24px',
  borderRadius: '4px',
  boxSizing: 'border-box',
  display: 'flex',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'block',
    marginLeft: '16px !important',
    marginRight: '16px !important'
  }
})

export const StyledFixedWidthContainer =
  styled.div<IStyledFixedWidthContainerProps>(
    ({ width }: IStyledFixedWidthContainerProps) => ({
      width: width ? `${width}px` : '100%',

      [mediaQueryDown(desktopUpBreakpoint)]: {
        width: '100%'
      }
    })
  )

export const StyledContainer = styled.div({
  padding: '0 8px',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    padding: 0
  }
})

export const StyledRow = styled.div({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  alignItems: 'baseline'
})

export const StyledColumn = styled.div<IStyledFixedWidthContainerProps>(
  (props) => ({
    flex: '0 0 auto',
    width: props.width ? `${props.width}px` : '100%',

    [mediaQueryDown(desktopUpBreakpoint)]: {
      flex: '1 1 100%',
      width: '100%'
    }
  })
)

export const StyledMobileColumn = styled.div<IStyledFixedWidthContainerProps>(
  (props) => ({
    flex: '0 0 auto',
    width: props.width ? `${props.width}px` : '100%',
    display: 'inline-flex',
    gap: '16px',
    alignItems: 'baseline',

    [mediaQueryDown(desktopUpBreakpoint)]: {
      flex: '1 1 100%',
      width: '100%'
    }
  })
)

export const StyledClinButton = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],

  [mediaQueryDown(desktopUpBreakpoint)]: {
    width: '100%',
    flex: 1
  }
})

export const StyledClinButtonMobile = styled(ClinButton)({
  width: ClinTheme.space[7],
  justifyContent: 'center',
  display: 'none',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'inline-flex'
  }
})

export const StyledInviteAnnounce = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: ClinTheme.colors.deliveryDateBackground,
  padding: ClinTheme.space[3],
  borderRadius: ClinTheme.radii[3],
  color: ClinTheme.colors.black,
  wordBreak: 'break-word',
  maxWidth: '1140px',
  margin: '0 auto',
  boxSizing: 'border-box',

  [mediaQueryDown(desktopUpBreakpoint)]: {
    flexDirection: 'column',
    gap: ClinTheme.space[3],
    marginLeft: '16px',
    marginRight: '16px',

    div: {
      textAlign: 'center'
    }
  }
})

export const StyledMessage = styled.div({
  marginRight: 'auto',
  flex: '1 0 0',
  color: ClinTheme.colors.primaryMid,
  marginLeft: ClinTheme.space[3],

  [mediaQueryDown(desktopUpBreakpoint)]: {
    marginLeft: 'auto'
  }
})

export const StyledClinGroup = styled(ClinGroup)({
  [mediaQueryDown(desktopUpBreakpoint)]: {
    display: 'block',

    '> :nth-child(n)': {
      margin: 0
    }
  }
})
